import userService from './userService';

const PROFILE_PERMISSIONS = {
  manager: [
    'DASHBOARD_VIEW',
    'DASHBOARD_UPDATE',
    'PRIORITY_VIEW',
    'PRIORITY_UPDATE',
    'CATALOG_VIEW',
    'CATALOG_UPDATE',
    'FILE_UPLOAD',
    'REPORT_DOWNLOAD',
    'CLIENT_ASSIGN'
  ],

  user: [
    'DASHBOARD_VIEW',
    'DASHBOARD_UPDATE'
  ],

  viewer: [
    'DASHBOARD_VIEW',
    'REPORT_DOWNLOAD'
  ],
};

const getPermissions = (email) => {
  const profile = userService.getProfile(email);

  return PROFILE_PERMISSIONS[profile] || [];
};

const hasPermission = (email, permission) => {
  return getPermissions(email).includes(permission);
};

const getProfile = (email) => {
  return userService.getProfile(email);
};

export const permissionService = {
  getPermissions,
  hasPermission,
  getProfile,
};

export default permissionService;